import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=ab62c6d6&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=ab62c6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab62c6d6",
  null
  
)

export default component.exports